import { CacheKey } from "@/modules/cache/constants";
import { GLOBAL_CACHE_INSTANCE } from "@/modules/cache/globalCache";
import {
  resolveCurrentGoogleAnalyticsClientIdFromBrowserCookie,
  resolveCurrentGoogleAnalyticsSessionIdFromBrowserCookie,
} from "@/modules/metrics/google-analytics.utils";

export const setMetricsGoogleAnalyticsClientId = async ({
  googleAnalyticsClientId,
}: {
  googleAnalyticsClientId: string;
}) => {
  await GLOBAL_CACHE_INSTANCE.set(CacheKey.MetricsGoogleAnalyticsClientId, {
    googleAnalyticsClientId,
  });
};

export const getMetricsGoogleAnalyticsClientId = async (): Promise<{
  googleAnalyticsClientId: string | null;
}> => {
  const cachedData = await GLOBAL_CACHE_INSTANCE.get(CacheKey.MetricsGoogleAnalyticsClientId, {
    keepInTabMemory: true,
  });

  if (cachedData) {
    return { googleAnalyticsClientId: cachedData?.googleAnalyticsClientId ?? null };
  }

  /**
   * If cached data isn't set, we fall-back to the current browser cookie.
   *
   * NOTE: In the electron client, this value will always be null.
   */
  const googleAnalyticsClientId = await resolveCurrentGoogleAnalyticsClientIdFromBrowserCookie();
  return { googleAnalyticsClientId: googleAnalyticsClientId ?? null };
};

export const clearMetricsGoogleAnalyticsClientId = async () => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.MetricsGoogleAnalyticsClientId);
};

export const setMetricsGoogleAnalyticsSessionId = async ({
  googleAnalyticsSessionId,
}: {
  googleAnalyticsSessionId: string;
}) => {
  await GLOBAL_CACHE_INSTANCE.set(CacheKey.MetricsGoogleAnalyticsSessionId, {
    googleAnalyticsSessionId,
  });
};

export const getMetricsGoogleAnalyticsSessionId = async (): Promise<{
  googleAnalyticsSessionId: string | null;
}> => {
  const cachedData = await GLOBAL_CACHE_INSTANCE.get(CacheKey.MetricsGoogleAnalyticsSessionId, {
    keepInTabMemory: true,
  });

  if (cachedData) {
    return { googleAnalyticsSessionId: cachedData?.googleAnalyticsSessionId ?? null };
  }

  /**
   * If cached data isn't set, we fall-back to the current browser cookie.
   *
   * NOTE: In the electron client, this value will always be null.
   */
  const googleAnalyticsSessionId = await resolveCurrentGoogleAnalyticsSessionIdFromBrowserCookie();
  return { googleAnalyticsSessionId: googleAnalyticsSessionId ?? null };
};

export const clearMetricsGoogleAnalyticsSessionId = async () => {
  await GLOBAL_CACHE_INSTANCE.del(CacheKey.MetricsGoogleAnalyticsSessionId);
};
